import {
  ACTION_SEEN,
  ACTION_SET,
  ACTION_SET_NEXT,
  ACTION_COMMENT_CHANGE,
  ACTION_RATING_CHANGE,
  ACTION_FEEDBACK_SUBMIT,
  ACTION_UNSET,
  ACTION_UNSEEN,
  ACTION_DONE,
  ACTION_LOGIN_SEEN,
  ACTION_DONE_REQUEST,
  ACTION_FEEDBACK_ERROR,
  ACTION_FEEDBACK_SUBMIT_REQUEST,
  ACTION_DONE_PERCENTAGE_CHANGE,
  ACTION_FEEDBACK_ACTION_DONE_CHANGE,
  ACTION_GET_NEW_ONE_REQUEST,
  ACTION_GET_NEW_ONE_ERROR,
  ACTION_GET_NEW_ONE_SUCCESS,
  ACTION_GET_ADMIN_REQUEST,
  ACTION_CHANGE,
  ACTION_FEEDBACK_SHARED_STATE,
  ACTION_FEEDBACK_SHARED_STATE_RESET,
  CHANGE_SEE_ACTION_AGAIN,
  CHANGE_ANALYSIS_TYPE,
} from "./constants";
import { VALIDATE_PERFECT_STEP_SUCCESS } from "../userCampaign/constants";
import moment from "moment-timezone";
import { LOGOUT } from "../login/constants";
import {
  MOBILE_CONNECTION_START,
  MOBILE_CONNECTION_STEP_CHANGE,
} from "../realTime/constants";
import { IActionReducer, ICategoryExample } from "./types";

const categoryExample: ICategoryExample = {
  title: "",
  category: "leadership",
  gains: "", // qu'est ce que c'est ? c'etait {} avant mais dans le types il est en string
  _id: "",
};

// category(pin): "leadership"
// title(pin): "Aujourd'hui, énoncer à votre équipe ce que vous avez identifié comme vos défauts/erreurs et énoncer le plan d'actions précis et délimité dans le temps que vous mettez en place pour y remedier."
// why(pin): "Etre capable de parler de ses défauts avec son équipe, c'est se montrer humain et être en mesure de travailler dessus."
// how(pin): "“Hello team, j’aimerais prendre 5 min pour me livrer une fois de plus à vous et avoir une discussion ouverte et bienveillante avec vous. <br> Cela fait maintenant 1 an que j’ai pris ce poste et j’ai réalisé que je n’étais pas assez présent pour vous. <br><br>Sauf que vous êtes réellement important pour moi et j’aimerai être un peu plus disponible pour vous. C’est pourquoi j’ai mis en place un créneau horaire de 15 min chaque jour que vous pouvez réserver un créneau disponible avec moi. J’ai appelé cet échange “Let’s walk and talk about anything we want”. “<br><br> PS: pour proposer et réserver des créneaux disponible, utiliser l’outils calendly (c’est gratuit) https://calendly.com/"
// goFurther(pin): "https://www.amazon.com/Subtle-Art-Giving-Smiths-Counterintuitive/dp/0062837508/ref=sr_1_fkmr2_2?ie=UTF8&qid=1534707351&sr=8-2-fkmr2&keywords=Mark+Ronson+The+Subtle+Art+of+Not+Giving+a+Fuck"

const initialState: IActionReducer = {
  requesting: false,
  successful: false,
  errors: {
    name: "",
    email: "",
    password: "",
  },
  nextCategory: "",
  language: "fr",
  category: "leadership",
  title: { fr: "", en: "" },
  description: { fr: "", en: "" },
  content: {
    title: { fr: "", en: "" },
    how: { fr: "", en: "" },
    why: { fr: "", en: "" },
  },
  action: categoryExample,
  actionSeen: false,
  nextAction: {},
  lastAction: {},
  comment: "",
  rating: 0,
  actionDone: "",
  actionState: "neutral",
  actionSeenDate: moment().subtract(1, "day").toDate(), // .toDate?
  isWaitingForConnection: false,
  donePercentage: 0,
  latest: "",
  oldTeamPoints: 0,
  oldUserPoints: 0,
  oldRank: 1,
  oldTeamRank: 1,
  repetitionNumber: 1,
  seeActionAgain: false,
  isShared: true,
  analysisType: "video",
};

const reducer = function actionReducer(
  state: IActionReducer = initialState,
  action,
): IActionReducer {
  switch (action.type) {
    case ACTION_LOGIN_SEEN: {
      const { nextCategory, actionSeenDate } = action.payload;
      return {
        ...state,
        nextCategory,
        actionSeenDate,
        actionSeen: true,
        actionState: "seen",
        isWaitingForConnection: false,
      };
    }

    case MOBILE_CONNECTION_STEP_CHANGE:
    case MOBILE_CONNECTION_START:
    case ACTION_CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case CHANGE_SEE_ACTION_AGAIN: {
      return {
        ...state,
        seeActionAgain: action.payload,
      };
    }

    case ACTION_SEEN: {
      const { latest, nextCategory } = action.payload;
      return {
        ...state,
        actionSeen: true,
        actionState: "seen",
        actionSeenDate: moment().toDate(),
        latest,
        isWaitingForConnection: false,
        nextCategory,
      };
    }

    // case offlineActionTypes.FETCH_OFFLINE_MODE: {
    //   if (action.payload.prevAction.type === ACTION_DONE_REQUEST) {
    //     return {
    //       ...state,
    //       isWaitingForConnection: true,
    //     };
    //   }
    //   return state;
    // }

    case ACTION_UNSEEN: {
      return {
        ...state,
        actionSeen: true,
      };
    }

    case ACTION_DONE: {
      return {
        ...state,
        requesting: false,
        actionState: "done",
      };
    }

    case ACTION_DONE_REQUEST: {
      return {
        ...state,
        requesting: true,
      };
    }

    case ACTION_SET:
      return {
        ...state,
        lastAction: { ...state.action },
        action: { ...action.payload },
        actionSeen: false,
      };

    case ACTION_SET_NEXT:
      return {
        ...state,
        nextAction: action.payload,
      };

    case ACTION_COMMENT_CHANGE:
      return {
        ...state,
        comment: action.payload,
      };

    case ACTION_DONE_PERCENTAGE_CHANGE:
      return {
        ...state,
        donePercentage: action.payload,
      };

    case ACTION_RATING_CHANGE:
      return {
        ...state,
        rating: action.payload,
      };

    case CHANGE_ANALYSIS_TYPE:
      return {
        ...state,
        analysisType: action.payload
      }

    case ACTION_FEEDBACK_ACTION_DONE_CHANGE:
      return {
        ...state,
        actionDone: action.payload,
      };

    case ACTION_FEEDBACK_SUBMIT_REQUEST:
      return {
        ...state,
        requesting: true,
      };

    case ACTION_FEEDBACK_SHARED_STATE:
      return {
        ...state,
        isShared: action.payload.isShared,
      };

    case ACTION_FEEDBACK_SHARED_STATE_RESET:
      return {
        ...state,
        isShared: true,
      };

    case VALIDATE_PERFECT_STEP_SUCCESS:
    case ACTION_FEEDBACK_SUBMIT:
      return {
        ...state,
        requesting: false,
        actionState: "done",
        // rating: 0,
        comment: "",
        actionDone: "",
        // donePercentage: null
      };

    case ACTION_FEEDBACK_ERROR:
      return {
        ...state,
        requesting: false,
      };

    case ACTION_GET_ADMIN_REQUEST:
    case ACTION_GET_NEW_ONE_REQUEST:
      return {
        ...state,
        requesting: true,
      };

    case ACTION_GET_NEW_ONE_ERROR:
      return {
        ...state,
        requesting: false,
        errors: action.payload,
      };

    case ACTION_GET_NEW_ONE_SUCCESS:
      return {
        ...state,
        requesting: false,
      };

    case LOGOUT:
    case ACTION_UNSET:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
